<template>
  <div class="meeting-attendance_wrapper">
    <div class="meeting_tags mb-2">
      <span class="mr-1 meeting_no">NO:</span>
      <span class="meeting_no">{{ meetingInfo.meetingNo }}</span>
      <el-divider direction="vertical"></el-divider>
      <el-tag
        size="mini"
        effect="dark"
        :type="meetingInfo.meetingImportantLevel"
      >
        {{ meetingInfo.v_meetingImportantLevel }}
      </el-tag>
      <el-divider direction="vertical"></el-divider>
      <el-tag
        size="mini"
        effect="dark"
        :type="
          meetingInfo.expoMeetingStatus === 'Y'
            ? 'Y'
            : meetingInfo.expoMeetingStatus === 'E'
            ? 'success'
            : meetingInfo.expoMeetingStatus === 'D'
            ? 'danger'
            : ''
        "
      >
        {{ meetingInfo.v_expoMeetingStatus }}
      </el-tag>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="peopleIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{ $l('from_label_attendance') || '会议负责人' }}</span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>{{
          convertsArrayString(meetingInfo.attendanceNameList) || 'None'
        }}</span>
      </div>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="clockBlueIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{ meetingInfo.meetingDate }}</span>
          <span class="ml-2">{{ meetingInfo.meetingWeek }}</span>
          <span>
            {{
              `${meetingInfo.meetingBeginTime} - ${meetingInfo.meetingEndTime}`
            }}
          </span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>{{ meetingInfo.v_meetingTimeZone }}</span>
      </div>
    </div>

    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="clockRedIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{ meetingInfo.meetingLocalDate }}</span>
          <span class="ml-2">{{ meetingInfo.meetingLocalWeek }}</span>
          <span>
            {{
              `${meetingInfo.meetingLocalBeginTime} - ${meetingInfo.meetingLocalEndTime}`
            }}
          </span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>{{ meetingInfo.meetingLocalTimeZone }}</span>
      </div>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="peopleIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{
            $l('from_label_attendance_customerName') || '客户参与人'
          }}</span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>{{ meetingInfo.customerName || 'None' }}</span>
      </div>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="contactsBookIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{
            $l('from_label_attendance_keyContact') || '客户主要联系方式'
          }}</span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>{{ meetingInfo.keyContact || 'None' }}</span>
      </div>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="mapPinsIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{
            $l('from_label_attendance_meetingLocation') || '会议地点'
          }}</span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <div v-if="meetingInfo.meetingLocation">
          <span>{{ meetingInfo.meetingLocation }}</span>
        </div>
        <div v-if="meetingInfo.meetingAddres">
          <span>{{ meetingInfo.meetingAddres }}</span>
        </div>
        <div v-if="!meetingInfo.meetingLocation && !meetingInfo.meetingAddres">
          <span>None</span>
        </div>
      </div>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="productCategoriesIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>{{
            $l('from_label_attendance_productCategories') || '产品分类'
          }}</span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>{{ meetingInfo.productCategories || 'None' }}</span>
      </div>
    </div>
    <div class="meeting-attendance_field-item">
      <div class="meeting-attendance_field-item_name">
        <div class="meeting-attendance_field-item_name-icon">
          <img :src="userGroupIcon" />
        </div>
        <div class="meeting-attendance_field-item_name-text">
          <span>
            {{ $l('from_label_attendance_merchandiser') || '我方参与人' }}
          </span>
        </div>
      </div>
      <div class="meeting-attendance_field-item_value">
        <span>
          {{ convertsArrayString(meetingInfo.merchandiserNameList) || 'None' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
const peopleIcon = require('../../icon/people.png')
const contactsBookIcon = require('../../icon/contacts-book.png')
const mapPinsIcon = require('../../icon/map-pins.png')
const productCategoriesIcon = require('../../icon/product-categories.png')
const userGroupIcon = require('../../icon/user-group.png')
const clockBlueIcon = require('../../icon/clock-blue.png')
const clockRedIcon = require('../../icon/clock-red.png')
export default {
  props: { meetingInfo: { type: Object, default: () => {} } },
  data() {
    return {
      peopleIcon,
      contactsBookIcon,
      mapPinsIcon,
      clockBlueIcon,
      clockRedIcon,
      productCategoriesIcon,
      userGroupIcon,
    }
  },
  methods: {
    convertsArrayString(str) {
      if (!str) return ''
      const data = JSON.parse(str)
      return data.join(' / ')
    },
  },
}
</script>

<style lang="scss" scoped>
.meeting-attendance_wrapper {
  height: 600px;
  overflow: auto;
  border-radius: 5px;
  padding: 12px 15px 12px 0;
}

.meeting-attendance_field-item {
  margin-bottom: 10px;
  .meeting-attendance_field-item_name {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .meeting-attendance_field-item_name-icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 6px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .meeting-attendance_field-item_name-text {
      line-height: 20px;
      color: rgba(108, 117, 125, 1);
      font-size: 14px;
    }
  }
  .meeting-attendance_field-item_value {
    line-height: 20px;
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    padding-left: 26px;
    word-wrap: word-break;
    word-break: break-all;
  }
}
.meeting_no {
  color: #6c6c6c;
  font-size: 14px;
}
</style>
